import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles({
    header: {
        width: "100%",
        textAlign: "center",
        padding: "20px 0",
        fontWeight: "bold",
        fontSize: "28"
    },
    buttonGroup: {
        width: "100%",
        padding: "15px 0",
        borderTop: "1px solid #eee",
        display: "flex",
        justifyContent: "flex-end"
    },
    container: {
        width: "600px",
        minHeight: "250px"
    },
    button: {
        marginRight: "10px"
    },
    close: {
        position: "absolute",
        top: "20px",
        right: "10px",
        cursor: "pointer"
    }
});

export default function ApproveRejectModal(props) {
    const { 
        isOpen = true, 
        handleClose, 
        headerText = "Approve or Reject",
        handleApprove,
        handleReject,
    } = props;
    const classes = useStyles();
    
    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={isOpen}>
            <div className={classes.container}>
                <div className={classes.header}>
                    {headerText}
                    <CloseIcon className={classes.close} onClick={handleClose} />
                </div>
                <div className={classes.buttonGroup}>
                    {handleApprove ? (<Button color="primary" className={classes.button} variant="contained" onClick={handleApprove}>Approve</Button>) : null}
                    {handleReject ? (<Button color="secondary" className={classes.button} variant="contained" onClick={handleReject}>Reject</Button>) : null}
                </div>
            </div>
        </Dialog>
    )
}